import { render } from "./RepairRequestForm.vue?vue&type=template&id=050dc098"
import script from "./RepairRequestForm.vue?vue&type=script&lang=js"
export * from "./RepairRequestForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/roshdfarms-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__